const STORAGE_KEY = 'qpoint:desktopLogin'
export const DESKTOP_LOGIN_PARAM = 'desktopLogin'

function sessionStore(): Storage | null {
  if (typeof window === 'undefined') return null
  try {
    return window.sessionStorage
  } catch {
    return null
  }
}

function hasDesktopLoginParam(): boolean {
  if (typeof window === 'undefined') return false
  return (
    new URLSearchParams(window.location.search).get(DESKTOP_LOGIN_PARAM) ===
    'true'
  )
}

export function latchDesktopLoginContext(): void {
  if (!hasDesktopLoginParam()) return
  sessionStore()?.setItem(STORAGE_KEY, '1')
}

export function isDesktopLoginContext(): boolean {
  if (hasDesktopLoginParam()) return true
  return sessionStore()?.getItem(STORAGE_KEY) === '1'
}
